module.exports = __webpack_public_path__ + "static/media/BG.a47670a8.png";